import React, { FC } from 'react';
import { ConstructionCard, Core, Button, Page } from '@everfi/reactifi';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TeacherWelcome: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Page pageType="parent" contentType="cards" title={''} backButton={false} usePageWrapper={true}>
      <ConstructionCard title={t('Welcome to EVERFI!')} alwaysExpanded={true} data-object-id="sso-teacher-weclome-card">
        <Core.Typography variant="p">
          {t('Before you get started, please give us a few more details to set up your Clever-integrated account.')}
        </Core.Typography>
        <Button
          data-action="continue"
          label={t('Continue')}
          rightIcon="arrow-right"
          style="primary"
          onClick={() => navigate('/teacher_registration/link')}
          className="float-end"
        />
      </ConstructionCard>
    </Page>
  );
};

export default TeacherWelcome;
